import {Injectable} from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { SchoolService } from './school.service';
import { HttpClient } from '@angular/common/http';
import { GlobalConstantsComponent } from '../shared/global-constants/global-constants.component';
import {PlatformService} from "./platform-service.service";

@Injectable()
export class LocalSettingsService {
  private apiUrl = GlobalConstantsComponent.apiURL;
  public sideNavTemplate: string;
  public headerTemplate: string;
  public currentSchoolSlug: string;
  public pageTitle: string;
  public goBack: boolean = false;
  public hasFooter: boolean = false;
  public currentComponent: string;
  public loadingType: string = 'loader';
  goBackChange: Subject<boolean> = new Subject<boolean>();
  isBrowser;
  localStorage;

  //variable de langue observable
  private languageSubject = new BehaviorSubject<string>(this.getLanguage());
  language$: Observable<string> = this.languageSubject.asObservable();


  //todo: better error handling!
  constructor(
    private schoolService: SchoolService,
    private platformService : PlatformService,
    private router: Router,
    private http: HttpClient,
  ) {
    this.isBrowser = platformService.isBrowserPlatform();
    this.localStorage = this.platformService.createLocalStorageServer();
    if (this.isBrowser) {
      this.localStorage = localStorage;
    }

    this.goBackChange.subscribe((value) => {
      this.goBack = value;
      if (value && this.currentComponent === '') {
        this.router.navigate(['discover']);
        this.toggleGoBack();
      }
    });
  }


  //@TODO : FAIRE UN CLEAN DES SERVICES


  toggleGoBack() {
    this.goBackChange.next(!this.goBack);
  }
  setCurrentComponent(value) {
    this.currentComponent = value;
  }

  setLoadingType(value) {
    this.loadingType = value;
  }

  getLoadingType() {
    return this.loadingType;
  }

  getRandomMessage() {
    return this.http.get(`${this.apiUrl}loadingMessages`);
  }

  getLanguage(): string {

    if (this.localStorage && this.localStorage['language']) {
      return this.localStorage['language'];
    }
    else {
      if(this.isBrowser){
        let language = navigator.language.split('-')[0];

        if(language === 'fr'){
          return language;
        }
        else{
          return 'en';
        }
      }
      return 'en';

    }
  }

  setLanguage(language: string) {
    if (this.localStorage) {
      if (!language) {
        language = 'en';
      }
      this.localStorage['language'] = language;
      this.languageSubject.next(language); // Émettre la nouvelle langue
    }
  }


  getZenDeskLang(){
    var lang = this.getLanguage();
    if(lang == 'en' || lang == null || lang == undefined || lang == ''){
      return 'en-us';
    }
    return lang;
  }
  getIconColors() {
    if (this.isBrowser){
      if (this.localStorage && this.localStorage['iconColors']) {
        return this.localStorage['iconColors'];
      } else {
        return '#f9a826';
      }
    }
    return '#f9a826';
  }

  setIconColors(color: string) {
    if (this.isBrowser){
      if (this.localStorage) {
        this.localStorage['iconColors'] = color;
      }
    }
  }

  setPrimaryColor(color: string) {
    if (this.localStorage) {
      this.localStorage['primaryColor'] = color;
    }
  }

  getPrimaryColor() {
    if (this.localStorage && this.localStorage['primaryColor']) {
      return this.localStorage['primaryColor'];
    }
    return false;
  }

  setBackgroundColor(color: string) {
    if (this.localStorage) {
      this.localStorage['backgroundColor'] = color;
    }
  }

  getBackgroundColor() {
    if (this.localStorage && this.localStorage['backgroundColor']) {
      return this.localStorage['backgroundColor'];
    }
    return false;
  }

  setSideNavTemplate(sideNavTemplate: string) {
    this.sideNavTemplate = sideNavTemplate;
  }

  getSideNavTemplate() {
    return this.sideNavTemplate;
  }

  setHeaderTemplate(headerTemplate: string) {
    this.headerTemplate = headerTemplate;
  }

  getHeaderTemplate() {
    return this.headerTemplate;
  }

  setFooterDisplay(display: boolean) {
    this.hasFooter = display;
  }

  getFooterDisplay() {
    return this.hasFooter;
  }

  setPageTitle(pageTitle: string) {
    this.pageTitle = pageTitle;
  }

  getPageTitle() {
    return this.pageTitle;
  }

  clear() {
    if (this.localStorage) {
      this.localStorage.clear();
    }
  }

  setReferer(referer: string) {
    if (this.localStorage) {
      this.localStorage['referer'] = referer;
    }
  }

  setUtm(utm) {
    if (this.isBrowser) {
      if (this.localStorage) {
        this.localStorage['utm'] = utm;
      }
    }
  }

  setClickid(clickid: string) {
    if (this.isBrowser) {
      if (this.localStorage) {
        this.localStorage['clickid'] = clickid;
      }
    }
  }

  getClickid() {
    if (this.localStorage && this.localStorage['clickid']) {
      return this.localStorage['clickid'];
    }
    return false;
  }

  getUtm() {
    if (this.localStorage && this.localStorage['utm']) {
      return this.localStorage['utm'];
    }
    return false;
  }

  getReferer() {
    if (this.localStorage && this.localStorage['referer']) {
      return this.localStorage['referer'];
    }
    return false;
  }

  // Setting getter
  getSetting() {
    return this.http.get(`${this.apiUrl}setting/get`) as any;
  }

  setTempObject(object) {
    if (this.localStorage) {
      this.localStorage['tempObject'] = JSON.stringify(object);
    }
    return false;
  }

  getTempObject() {
    if (this.localStorage && this.localStorage['tempObject']) {
      return JSON.parse(this.localStorage['tempObject']);
    }
    return false;
  }
}
